import { useInView } from './hooks/useInView';

export default function Community() {
  const [ref, inView] = useInView();

  return (
    <section className="community section" id="community" ref={ref}>
      <div className="container">
        <div className={`reveal ${inView ? 'in-view' : ''}`}>
          <div className="section-label">Community & Governance</div>
          <h2 className="section-title section-title--lg" style={{ marginBottom: '1rem', maxWidth: '700px' }}>
            Ownership becomes{' '}
            <span className="gradient-text">collective, not extractive.</span>
          </h2>
          <p className="section-body" style={{ marginBottom: '3rem' }}>
            NOMO integrates cooperative structures and blockchain-based communication —
            merging value participation with community ownership at every layer.
          </p>
        </div>

        <div className="glass-wrap">
          <div className={`community__inner stagger ${inView ? 'in-view' : ''}`}>
            <div className="community__card">
              <div className="community__card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
                <div className="community__card-title" style={{ marginBottom: 0 }}>Decentralized Messenger</div>
                <span className="tag" style={{ fontSize: '0.58rem', letterSpacing: '0.1em' }}>Rolling Out</span>
              </div>
              <p className="community__card-desc">
                Blockchain-based communication with value transfer built in. Send crypto as easily
                as sending a message — using names, not wallet addresses.
              </p>
              <div className="community__features">
                {[
                  'Text messaging',
                  'Name-to-name crypto transfers',
                  'No exposed wallet addresses',
                  'Blockchain-anchored, encrypted',
                  'Voice & video — expanding soon',
                ].map((f) => (
                  <div className="community__feature" key={f}>
                    <span className="community__feature-dot" />
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="community__card">
              <div className="community__card-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div className="community__card-title">Cooperative Governance</div>
              <p className="community__card-desc">
                Members participate in decision-making and share in the ecosystem's growth.
                NOMO's cooperative structure creates alignment between users, developers, and the platform.
              </p>
              <div className="community__features">
                {[
                  'Priority access to ecosystem opportunities',
                  'On-chain governance models',
                  'Community pooling mechanisms',
                  'Shared ownership structures',
                  'Aligned incentives across all participants',
                ].map((f) => (
                  <div className="community__feature" key={f}>
                    <span className="community__feature-dot" />
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={`reveal ${inView ? 'in-view' : ''}`}
            style={{
              marginTop: '1.5rem',
              padding: '1.5rem',
              background: 'rgba(0,0,0,0.28)',
              borderRadius: '14px',
              textAlign: 'center',
            }}
          >
            <p
              style={{
                fontFamily: 'var(--font-primary)',
                fontSize: 'clamp(1rem, 2vw, 1.4rem)',
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: 'var(--white-muted)',
              }}
            >
              Web3 + Identity + Governance + Community.{' '}
              <span className="gradient-text">In one app.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
